import { Modal } from "antd";
import { ReactNode } from "react";

type TModal = {
  title?: string | ReactNode;
  onCancel: () => void;
  openModal: boolean;
  children: ReactNode;
  width?: number;
  closeIcon: boolean;
  center?: boolean;
  className?: string;
  top?: string;
  blur?: boolean;
  zIndex?: number;
};
const FBModal = ({
  title,
  onCancel,
  openModal,
  children,
  width,
  center,
  closeIcon,
  className,
  top = "20px",
  blur = true,
  zIndex = 999,
}: TModal) => {
  return (
    <Modal
      width={width}
      zIndex={zIndex}
      title={
        title ? (
          typeof title === "string" ? (
            <h1
              className={`text-[15px] ${className ? "p-5 border-[#F6F6F6] border-b" : ""} font-bold text-black-primary`}
            >
              {title}
            </h1>
          ) : (
            title
          )
        ) : null
      }
      onCancel={onCancel}
      open={openModal}
      footer={null}
      style={{ top: center ? "" : top }}
      closeIcon={closeIcon}
      className={`${className && className}`}
      closable={false}
      mask={blur}
    >
      {children}
    </Modal>
  );
};

export default FBModal;
